import React, { useState } from 'react';
import { Search, Filter, MapPin, Clock, Star, ShoppingBag } from 'lucide-react';
import Button from '../../components/ui/Button';
import Input from '../../components/ui/Input';

const AvailableBags = () => {
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedCategory, setSelectedCategory] = useState('all');

  const mockBags = [
  {
    id: 1,
    business: 'Café Tapatío',
    image: "https://images.unsplash.com/photo-1521099238480-47462c152711",
    alt: 'Deliciosa selección de café, pasteles y pan dulce mexicano del Café Tapatío',
    originalPrice: 150,
    discountPrice: 50,
    category: 'Café y Panadería',
    distance: '0.8 km',
    rating: 4.8,
    pickupTime: '18:00 - 20:00',
    available: 5
  },
  {
    id: 2,
    business: 'Restaurante La Chata',
    image: "https://images.unsplash.com/photo-1598763773372-127da881eb84",
    alt: 'Auténtica comida mexicana con tacos, enchiladas y platillos tradicionales',
    originalPrice: 280,
    discountPrice: 90,
    category: 'Comida Mexicana',
    distance: '1.2 km',
    rating: 4.6,
    pickupTime: '19:00 - 21:00',
    available: 3
  },
  {
    id: 3,
    business: 'Panadería San José',
    image: "https://images.unsplash.com/photo-1592135091406-308008ca5c2c",
    alt: 'Variedad de pan fresco, pasteles y productos de panadería artesanal',
    originalPrice: 120,
    discountPrice: 40,
    category: 'Panadería',
    distance: '0.5 km',
    rating: 4.9,
    pickupTime: '17:30 - 19:30',
    available: 8
  },
  {
    id: 4,
    business: 'Pizzería Italiana',
    image: "https://images.unsplash.com/photo-1618304925022-f50a402ae065",
    alt: 'Pizza italiana auténtica con ingredientes frescos y masa artesanal',
    originalPrice: 350,
    discountPrice: 120,
    category: 'Pizza',
    distance: '2.1 km',
    rating: 4.7,
    pickupTime: '20:00 - 22:00',
    available: 2
  },
  {
    id: 5,
    business: 'Sushi Guadalajara',
    image: "https://images.unsplash.com/photo-1523617871-823acb863c98",
    alt: 'Sushi fresco y rollos especiales preparados por chefs japoneses',
    originalPrice: 450,
    discountPrice: 150,
    category: 'Comida Japonesa',
    distance: '1.8 km',
    rating: 4.9,
    pickupTime: '19:30 - 21:30',
    available: 4
  },
  {
    id: 6,
    business: 'Heladería Artesanal',
    image: "https://images.unsplash.com/photo-1567807371534-0477696eaff9",
    alt: 'Helados artesanales de sabores únicos y postres cremosos',
    originalPrice: 180,
    discountPrice: 60,
    category: 'Postres',
    distance: '0.9 km',
    rating: 4.7,
    pickupTime: '16:00 - 18:00',
    available: 6
  }];


  const categories = ['all', 'Café y Panadería', 'Comida Mexicana', 'Panadería', 'Pizza', 'Comida Japonesa', 'Postres'];

  const filteredBags = mockBags?.filter((bag) => {
    const matchesSearch = bag?.business?.toLowerCase()?.includes(searchTerm?.toLowerCase()) ||
    bag?.category?.toLowerCase()?.includes(searchTerm?.toLowerCase());
    const matchesCategory = selectedCategory === 'all' || bag?.category === selectedCategory;
    return matchesSearch && matchesCategory;
  });

  const handleImageError = (e) => {
    e.target.src = '/assets/images/no_image.png';
    e.target.alt = 'Imagen no disponible';
  };

  return (
    <div className="min-h-screen bg-gray-50 pt-24">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        {/* Header */}
        <div className="mb-8">
          <h1 className="text-3xl font-bold text-gray-900 mb-4">
            Bolsas Disponibles
          </h1>
          <p className="text-gray-600">
            Encuentra y reserva bolsas sorpresa de tus restaurantes favoritos en Guadalajara
          </p>
        </div>

        {/* Search and Filters */}
        <div className="mb-8 space-y-4">
          <div className="flex flex-col sm:flex-row gap-4">
            <div className="flex-1 relative">
              <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 h-5 w-5" />
              <Input
                placeholder="Buscar por restaurante o tipo de comida..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e?.target?.value)}
                className="pl-10" />

            </div>
            <Button variant="outline" className="sm:w-auto w-full">
              <Filter className="h-4 w-4 mr-2" />
              Filtros
            </Button>
          </div>

          {/* Category Filter */}
          <div className="flex gap-2 overflow-x-auto pb-2">
            {categories?.map((category) =>
            <button
              key={category}
              onClick={() => setSelectedCategory(category)}
              className={`px-4 py-2 rounded-full text-sm font-medium whitespace-nowrap transition-colors ${
              selectedCategory === category ?
              'bg-green-600 text-white' : 'bg-white text-gray-600 hover:bg-gray-50 border border-gray-200'}`
              }>

                {category === 'all' ? 'Todas las categorías' : category}
              </button>
            )}
          </div>
        </div>

        {/* Results */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {filteredBags?.map((bag) =>
          <div key={bag?.id} className="bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-xl transition-shadow">
              <div className="relative">
                <img
                src={bag?.image}
                alt={bag?.alt || `Bolsa sorpresa de ${bag?.business}`}
                className="w-full h-48 object-cover"
                onError={handleImageError}
                loading="lazy" />

                <div className="absolute top-4 right-4 bg-green-600 text-white px-2 py-1 rounded-full text-sm font-medium">
                  {bag?.available} disponibles
                </div>
              </div>

              <div className="p-6">
                <div className="flex items-center justify-between mb-2">
                  <h3 className="font-bold text-lg text-gray-900">{bag?.business}</h3>
                  <div className="flex items-center text-yellow-500">
                    <Star className="h-4 w-4 fill-current" />
                    <span className="text-sm ml-1 text-gray-600">{bag?.rating}</span>
                  </div>
                </div>

                <p className="text-gray-600 text-sm mb-3">{bag?.category}</p>

                <div className="flex items-center text-sm text-gray-500 mb-4">
                  <MapPin className="h-4 w-4 mr-1" />
                  <span>{bag?.distance}</span>
                  <Clock className="h-4 w-4 ml-4 mr-1" />
                  <span>{bag?.pickupTime}</span>
                </div>

                <div className="flex items-center justify-between mb-4">
                  <div className="flex items-center space-x-2">
                    <span className="text-2xl font-bold text-green-600">
                      ${bag?.discountPrice}
                    </span>
                    <span className="text-sm text-gray-500 line-through">
                      ${bag?.originalPrice}
                    </span>
                  </div>
                  <div className="text-sm text-green-600 font-medium">
                    {Math.round((1 - bag?.discountPrice / bag?.originalPrice) * 100)}% desc.
                  </div>
                </div>

                <Button className="w-full bg-green-600 hover:bg-green-700">
                  <ShoppingBag className="h-4 w-4 mr-2" />
                  Reservar Bolsa
                </Button>
              </div>
            </div>
          )}
        </div>

        {filteredBags?.length === 0 &&
        <div className="text-center py-16">
            <ShoppingBag className="h-16 w-16 text-gray-400 mx-auto mb-4" />
            <h3 className="text-xl font-medium text-gray-900 mb-2">
              No se encontraron bolsas
            </h3>
            <p className="text-gray-600">
              Prueba con otros términos de búsqueda o revisa más tarde.
            </p>
          </div>
        }
      </div>
    </div>);

};

export default AvailableBags;